export const approverRoutes = [
  {
    path: '/approvers',
    name: 'approvers',
    component: () => import('./views/ListApprovers.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['admin', 'superadmin', 'admin users & supervisors'],
    },
  },
  {
    path: '/payrollsConfig/:id/approvalFlows',
    name: 'approvalFlows',
    component: () => import('./views/ListApprovalFlows.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['admin', 'superadmin'],
    },
  },
  {
    path: '/payrollsConfig/:id/approvalFlows/add',
    name: 'CreateApprovalFlow',
    component: () => import('./views/CreateApprovalFlow.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['admin', 'superadmin'],
    },
  },
  {
    path: '/payrollsConfig/:id/approvalFlows/detail/:flowId',
    name: 'ApprovalFlowDetail',
    component: () => import('./views/ApprovalFlowDetail.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['admin', 'superadmin'],
    },
  },
  {
    path: '/requestHistory',
    name: 'RequestHistory',
    component: () => import('./views/RequestHistory.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['supervisor'],
    },
  },
  {
    path: '/requestApprover',
    name: 'RequestApprover',
    component: () => import('./views/RequestApprover.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['supervisor'],
    },
  },
  {
    path: '/requestDetail/:id/from/:from',
    name: 'RequestDetail',
    component: () => import('./views/RequestDetail.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['supervisor', 'admin', 'superadmin'],
    },
  },
  {
    path: '/requestApprover/:id',
    name: 'RequestApproverDetail',
    component: () => import('./views/RequestDetail.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['supervisor'],
    },
  },
  {
    path: '/EmployeesAsigned',
    name: 'EmployeesAsigned',
    component: () => import('./views/EmployeesAssigned.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['supervisor'],
    },
  },
]
